import { StorageKeys } from './../../constants/StorageKeys';
import { AuthenticationResultDTO, Claim, NotificationDTO } from 'src/services/generated/api.generated.v1';
import { MutationTree } from 'vuex';
import { UserStateInterface } from './state';
import { ClaimTypes } from '../../constants/ClaimTypes';
import { ClaimHelper } from 'src/utils';

const ACTIVE_VEHICLE_KEY = 'ACTIVE_VEHICLE_UID';
const REMEBERED_USERNAME = 'REMEMBERED_USERNAME';

const mutation: MutationTree<UserStateInterface> = {
  updateUserState(state: UserStateInterface, authResult: AuthenticationResultDTO) {
    state.id = ClaimHelper.GetClaimValue(authResult?.claims, ClaimTypes.NAME_IDENTIFIER);
    state.email = ClaimHelper.GetClaimValue(authResult?.claims, ClaimTypes.EMAIL);
    state.firstName = ClaimHelper.GetClaimValue(authResult?.claims, ClaimTypes.FIRST_NAME);
    state.lastName = ClaimHelper.GetClaimValue(authResult?.claims, ClaimTypes.SURNAME);
    state.zipCode = ClaimHelper.GetClaimValue(authResult?.claims, ClaimTypes.POSTAL_CODE);
    state.permissions = ClaimHelper.GetClaimValues(authResult?.claims, ClaimTypes.PERMISSION);

    state.vehicles = getVehicleClaims(authResult?.claims);

    state.termsAndConditionsAccepted = !!ClaimHelper.GetClaimValue(authResult?.claims, ClaimTypes.TERMS_AND_CONDITIONS_ACCEPTED);
    state.allowPushNotifications = !!ClaimHelper.GetClaimValue(authResult?.claims, ClaimTypes.ALLOW_PUSH_NOTIFICATIONS);
    
    window.localStorage.setItem(StorageKeys.USERID, <string>state.id);

    const username = window.localStorage.getItem(REMEBERED_USERNAME);

    if(username && username != '') {
      state.rememberUsername = true;
      state.username = username;
    }
  },

  setRememberedUsername(state: UserStateInterface, username: string) {
    window.localStorage.setItem(REMEBERED_USERNAME, username);
    state.rememberUsername = true;
    state.username = username;
    
  },

  setPrimaryVehicle(state: UserStateInterface, vehicleUid: string) {
    const vehicles = state.vehicles;
    vehicles.forEach(x => x.isActive = x.uid === vehicleUid);

    window.localStorage.setItem(ACTIVE_VEHICLE_KEY, vehicleUid);

    state.vehicles = vehicles;
  },

  setNotifications(state: UserStateInterface, notifications: Array<NotificationDTO>) {
    state.notifications = notifications;
  },

  setNotificationRead(state: UserStateInterface, notificationUid: string)  {

    const notificationIndex = state.notifications.findIndex(x => x.userNotificationUid === notificationUid);

    if (notificationIndex) {
      state.notifications[notificationIndex].isRead = true;
    }
  },

  deleteRememberedUsername(state: UserStateInterface) {
    window.localStorage.removeItem(REMEBERED_USERNAME);
    state.rememberUsername = false;
    state.username = '';
  },

  deleteNotification(state: UserStateInterface, notificationUid: string)  {

    const notificationIndex = state.notifications.findIndex(x => x.userNotificationUid === notificationUid);

    if (notificationIndex) {
      const allNotifications = state.notifications;
      state.notifications = allNotifications.splice(notificationIndex, 1);
    }
  },
}

function getVehicleClaims(claims: Array<Claim> | null | undefined) {
  const getUid = (props: { [key: string]: string; } | null | undefined) => props ? props['Uid'] : '';
  const getDisplayName = (props: { [key: string]: string; } | null | undefined) => props ? props['Name'] : '';

  const activeVehicle = window.localStorage.getItem(ACTIVE_VEHICLE_KEY);

  const vehicles = ClaimHelper.GetClaims(claims, ClaimTypes.VEHICLE_IDENTIFICATION_NUMBER)
    .map(x => ({
      vin: <string>x.value,
      uid: getUid(x.properties),
      permissions: ClaimHelper.GetClaimValues(claims, `${ClaimTypes.VEHICLE_PERMISSION}/${getUid(x.properties)}`),
      isActive: activeVehicle !== null && activeVehicle === getUid(x.properties),
      displayName: getDisplayName(x.properties)
    }));

  if (vehicles && vehicles.length > 0 &&
     (vehicles.length === 1 || vehicles.every(x => !x.isActive)))  {
    vehicles[0].isActive = true;
  }

  return vehicles ?? [];
}

export default mutation;